$(function () {
  $('ul > .accordion span').on("click", function() {
    $(this).next().slideToggle(600);
    $(this).toggleClass("active");//追加部分
  });
    
  var $nav = $('.g-nav');
  // 開く
  $('.menu-trigger').on('click', function (e) {
    e.preventDefault();
    $nav.fadeIn(200);
    $('body').addClass('is-nav-open');
  });

  // 閉じる（closeボタン）
  $nav.on('click', '.close', function (e) {
    e.preventDefault();
    $nav.fadeOut(200);
    $('body').removeClass('is-nav-open');
  });
});
